import { Outlet } from 'react-router-dom';
import { CalendarWeek } from '@/domain/termine/features/Calendar/Grid/CalendarWeek';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { Day } from '@/domain/termine/type';

export function CalendarGrid() {
  const { startDate, endDate } = useCalendarContext();

  const days: Day[] = [];
  let current = startDate.clone();
  while (!current.isAfter(endDate)) {
    days.push(current.clone());
    current = current.add(1, 'day');
  }

  const weeks: Day[][] = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }
  return (
    <>
      <div className="flex flex-col border border-neutrals-N300 rounded-xl bg-white overflow-hidden">
        {weeks.map((week) => (
          <div
            key={week[0].format('YYYY-MM-DD')}
            className="last:border-b-0 border-b border-neutrals-N300">
            <CalendarWeek week={week} />
          </div>
        ))}
      </div>
      <Outlet />
    </>
  );
}
